import { RouterConfig } from "@shared/lib/routerConfig";
import { AutoIcon } from "@shared/ui/Icon/ui/Navigation/AutoIcon";
import { BlogIcon } from "@shared/ui/Icon/ui/Navigation/BlogIcon";
import { ContactsIcon } from "@shared/ui/Icon/ui/Navigation/ContactsIcon";
import { DocumentsIcon } from "@shared/ui/Icon/ui/Navigation/DocumentsIcon";
import { EstimateIcon } from "@shared/ui/Icon/ui/Navigation/EstimateIcon";
import { HistoryIcon } from "@shared/ui/Icon/ui/Navigation/history-icon";
import { InsuranceIcon } from "@shared/ui/Icon/ui/Navigation/InsuranceIcon";
import { JobIcon } from "@shared/ui/Icon/ui/Navigation/JobIcon";
import { MarketsIcon } from "@shared/ui/Icon/ui/Navigation/MarketsIcon";
import { PropertyIcon } from "@shared/ui/Icon/ui/Navigation/PropertyIcon";
import { MenuItem } from "./types";

export const MenuItems: MenuItem[] = [
    {
        title: "Автомобили",
        icon: AutoIcon,
        link: RouterConfig.CATALOG_ALL
    },
    {
        title: "Работа",
        icon: JobIcon,
        link: RouterConfig.JOB
    },
    {
        title: "Страхование",
        icon: InsuranceIcon,
        link: RouterConfig.INSURANCE
    },
    {
        title: "Отчеты",
        icon: HistoryIcon,
        link: RouterConfig.HISTORY
    },
    {
        title: "Документы",
        icon: DocumentsIcon,
        link: RouterConfig.GENERATOR_DKP
    },
    {
        title: "Оценка авто",
        icon: EstimateIcon,
        link: RouterConfig.ANALYTICS
    },
    {
        title: "Блог",
        icon: BlogIcon,
        link: RouterConfig.BLOG
    },
    {
        title: "Общие контакты",
        icon: ContactsIcon,
        link: RouterConfig.CONTACTS
    },
    {
        title: "Недвижимость",
        icon: PropertyIcon,
        link: RouterConfig.PROPERTY
    },
    {
        title: "Маркетплейсы",
        icon: MarketsIcon,
        link: RouterConfig.MARKETPLACES
    }
];